export default "__VITE_ASSET__eACeiO5E__"